import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const API = 'https://groovie-business-api-production.up.railway.app/api/v1';

const BIZ_TYPES = [
  { value: 'gym', label: 'Gym / Fitness Center' }, { value: 'retail_store', label: 'Retail Store' },
  { value: 'restaurant', label: 'Restaurant' }, { value: 'hotel', label: 'Hotel' },
  { value: 'spa', label: 'Spa / Wellness' }, { value: 'medical', label: 'Medical / Healthcare' },
  { value: 'corporate', label: 'Corporate Office' }, { value: 'religious_institution', label: 'Religious Institution' },
  { value: 'warehouse', label: 'Warehouse' }, { value: 'education', label: 'Education' },
  { value: 'others', label: 'Others' },
];

const Svg = ({ type, size = 16 }) => {
  const icons = {
    radio: <><circle cx="12" cy="12" r="2"/><path d="M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"/></>,
    building: <><rect x="4" y="2" width="16" height="20" rx="2"/><line x1="9" y1="6" x2="9" y2="6.01"/><line x1="15" y1="6" x2="15" y2="6.01"/><line x1="9" y1="10" x2="9" y2="10.01"/><line x1="15" y1="10" x2="15" y2="10.01"/><line x1="9" y1="14" x2="9" y2="14.01"/><line x1="15" y1="14" x2="15" y2="14.01"/><line x1="9" y1="18" x2="15" y2="18"/></>,
    user: <><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></>,
    mail: <><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></>,
    lock: <><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></>,
    arrow: <><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12,5 19,12 12,19"/></>,
    eye: <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>,
    eyeOff: <><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></>,
    grid: <><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></>,
  };
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{icons[type]}</svg>;
};

const inputStyle = {
  width: '100%', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 12,
  padding: '13px 16px 13px 44px', fontSize: 15, outline: 'none',
  fontFamily: "'Outfit', sans-serif", boxSizing: 'border-box',
  transition: 'border-color 0.15s, box-shadow 0.15s',
  background: 'rgba(255,255,255,0.05)', color: '#fff',
};
const selectStyle = { ...inputStyle, padding: '13px 16px 13px 44px', background: 'rgba(255,255,255,0.05)', appearance: 'none', color: '#fff' };
const focusIn = (e) => { e.target.style.borderColor = '#7c3aed'; e.target.style.boxShadow = '0 0 0 3px rgba(124,58,237,0.1)'; };
const focusOut = (e) => { e.target.style.borderColor = 'rgba(255,255,255,0.1)'; e.target.style.boxShadow = 'none'; };

export default function Register() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [formData, setFormData] = useState({ companyName: '', email: '', password: '', name: '', businessType: 'retail_store' });
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault(); setError('');
    if (!termsAccepted) { setError('Please accept the Terms of Service to continue.'); return; }
    setLoading(true);
    try {
      const res = await fetch(`${API}/auth/register`, { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ company_name: formData.companyName, email: formData.email, password: formData.password, name: formData.name, business_type: formData.businessType, terms_accepted: true })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Registration failed');
      localStorage.setItem('token', data.token);
      localStorage.setItem('company', JSON.stringify(data.company));
      if (data.admin) localStorage.setItem('user', JSON.stringify(data.admin));
      navigate('/dashboard');
    } catch (err) { setError(err.message || 'Registration failed.'); }
    finally { setLoading(false); }
  };

  const iconInput = (label, icon, type, key, placeholder, opts = {}) => (
    <div style={{ marginBottom: 16 }}>
      <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.6)', marginBottom: 6 }}>{label}</label>
      <div style={{ position: 'relative' }}>
        <div style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: 'rgba(255,255,255,0.3)' }}><Svg type={icon} size={16} /></div>
        {opts.select ? (
          <select required value={formData[key]} onChange={(e) => setFormData({ ...formData, [key]: e.target.value })} style={selectStyle} onFocus={focusIn} onBlur={focusOut}>
            {opts.options.map(o => <option key={o.value} value={o.value} style={{color: "#111", background: "#fff"}}>{o.label}</option>)}
          </select>
        ) : (
          <>
            <input type={opts.isPw && showPw ? 'text' : type} required={opts.required !== false} minLength={opts.minLength}
              value={formData[key]} onChange={(e) => setFormData({ ...formData, [key]: e.target.value })}
              placeholder={placeholder} style={inputStyle} onFocus={focusIn} onBlur={focusOut} />
            {opts.isPw && (
              <button type="button" onClick={() => setShowPw(!showPw)} style={{ position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'rgba(255,255,255,0.3)', padding: 0 }}>
                <Svg type={showPw ? 'eyeOff' : 'eye'} size={16} />
              </button>
            )}
          </>
        )}
      </div>
      {opts.hint && <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.3)', marginTop: 4 }}>{opts.hint}</p>}
    </div>
  );

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#0a0a0a',
      fontFamily: "'Outfit', 'DM Sans', sans-serif", padding: 16, position: 'relative', overflow: 'hidden',
    }}>
      <div style={{ position: 'absolute', top: -120, left: -120, width: 400, height: 400, borderRadius: '50%', background: 'radial-gradient(circle, rgba(168,85,247,0.05), transparent 70%)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: -100, right: -100, width: 350, height: 350, borderRadius: '50%', background: 'radial-gradient(circle, rgba(124,58,237,0.06), transparent 70%)', pointerEvents: 'none' }} />

      <div style={{
        background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 24, maxWidth: 440, width: '100%',
        padding: '36px 36px 32px', boxShadow: '0 25px 80px rgba(0,0,0,0.3)', position: 'relative',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 28, cursor: 'pointer' }} onClick={() => { window.location.href = 'https://groovie.live'; }} title="Groovie home">
          <div style={{
            width: 56, height: 56, borderRadius: 16, margin: '0 auto 14px',
            background: 'linear-gradient(135deg, #7c3aed, #a855f7)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff',
            boxShadow: '0 8px 24px rgba(124,58,237,0.4)',
          }}><Svg type="radio" size={28} /></div>
          <h1 style={{ fontSize: 26, fontWeight: 800, color: '#111827', margin: '0 0 4px', letterSpacing: '-0.5px' }}>Join Groovie Business</h1>
          <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.3)', margin: 0 }}>Start your AI-powered radio journey</p>
        </div>

        {error && (
          <div style={{ marginBottom: 18, padding: '12px 16px', borderRadius: 10, background: '#fef2f2', border: '1px solid #fecaca', color: '#dc2626', fontSize: 13 }}>{error}</div>
        )}

        <form onSubmit={handleSubmit}>
          {iconInput('Company Name *', 'building', 'text', 'companyName', 'Acme Corporation')}
          {iconInput('Business Type *', 'grid', 'text', 'businessType', '', { select: true, options: BIZ_TYPES })}
          {iconInput('Your Name *', 'user', 'text', 'name', 'John Doe')}
          {iconInput('Email Address *', 'mail', 'email', 'email', 'you@company.com')}
          {iconInput('Password *', 'lock', 'password', 'password', 'Create a password', { isPw: true, minLength: 6, hint: 'Minimum 6 characters' })}

          <div style={{ marginTop: 8, marginBottom: 16, display: 'flex', alignItems: 'flex-start', gap: 10 }}>
            <input type="checkbox" id="terms" checked={termsAccepted} onChange={(e) => setTermsAccepted(e.target.checked)}
              style={{ width: 18, height: 18, marginTop: 2, accentColor: '#7c3aed', cursor: 'pointer', flexShrink: 0 }} />
            <label htmlFor="terms" style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', lineHeight: 1.5, cursor: 'pointer' }}>
              I agree to the <Link to="/terms" target="_blank" style={{ color: '#7c3aed', fontWeight: 600, textDecoration: 'none' }}>Terms of Service</Link>,{' '}
              <Link to="/privacy" target="_blank" style={{ color: '#7c3aed', fontWeight: 600, textDecoration: 'none' }}>Privacy Policy</Link>, and{' '}
              <Link to="/license-info" target="_blank" style={{ color: '#7c3aed', fontWeight: 600, textDecoration: 'none' }}>License Agreement</Link>
            </label>
          </div>

          <button type="submit" disabled={loading} style={{
            width: '100%', padding: '14px 20px', borderRadius: 12, border: 'none', marginTop: 8,
            background: loading ? '#c4b5fd' : 'linear-gradient(135deg, #7c3aed, #a855f7)',
            color: '#fff', fontSize: 16, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer',
            fontFamily: "'Outfit', sans-serif", boxShadow: '0 4px 16px rgba(124,58,237,0.35)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
            transition: 'transform 0.15s, box-shadow 0.15s',
          }}
          onMouseEnter={(e) => { if (!loading) { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 6px 24px rgba(124,58,237,0.45)'; } }}
          onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(124,58,237,0.35)'; }}
          >
            {loading ? 'Creating Account...' : <><span>Create Account</span> <Svg type="arrow" size={16} /></>}
          </button>
        </form>

        <div style={{ marginTop: 20, textAlign: 'center' }}>
          <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.4)', margin: 0 }}>
            Already have an account?{' '}
            <Link to="/login" style={{ color: '#7c3aed', fontWeight: 700, textDecoration: 'none' }}>Sign In</Link>
          </p>
        </div>
      </div>
    </div>
  );
}